import React from 'react';
import PropTypes from 'prop-types';

const FieldLabelAndError = ({ label, required }) => (
    <div className="w-full mb-0 md:mb-1">
        <label className="block text-gray-700 mb-1 md:mb-0 pl-1">
            {label}{' '}
            {required && (
                <span className="text-sm text-red-500 my-0 md:mb-0"> * </span>
            )}
        </label>
    </div>
);

FieldLabelAndError.propTypes = {
    label: PropTypes.string,
    required: PropTypes.bool,
    meta: PropTypes.object,
    info: PropTypes.string,
};

export default FieldLabelAndError;
